<template>
  <div>
    <div style="display: flex; align-items: flex-start">
      <sidebar style="margin-right: 20px; max-width: 200px" />
      <el-card style="width: 100%">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Termékek</span>
          <el-button
            v-can="'data.product.create'"
            style="float: right; margin-top: -5px;"
            type="success"
            size="small"
            icon="el-icon-plus"
            @click="$router.replace('/data/products/add')"
          >
            Új Termék
          </el-button>
        </div>
        <table-filter
          v-if="config"
          :config="config"
          action="product/fetchAllWithPagination"
        />
        <list />
        <template v-if="$route.meta.showProductViewDialog">
          <product-view-dialog
            :productId="$route.params.id"
          />
        </template>
        <template v-if="$route.meta.showAddProductDialog">
          <product-dialog
            type="add"
          />
        </template>
        <template v-if="$route.meta.showUpdateProductDialog">
          <product-dialog
            :product-id="$route.params.id"
            type="update"
          />
        </template>
      </el-card>
    </div>
  </div>
</template>
<script>
  import Sidebar from '../../../components/data/products/Sidebar';
  import List from '../../../components/data/products/products/List';
  import ProductDialog from '../../../components/data/products/products/Dialog';
  import ProductViewDialog from '../../../components/data/products/products/View';
  import TableFilter from '../../../components/TableFilter';

  export default {
    components: {
      Sidebar,
      List,
      ProductDialog,
      TableFilter,
      ProductViewDialog,
    },
    data() {
      return {
        config: null,
      };
    },
    async mounted() {
      await this.setConfig();
    },
    methods: {
      async setConfig() {
        let productCategories = this.$store.getters['productCategory/productCategories'];
        let manufacturers = this.$store.getters['manufacturer/manufacturers'];
        let customsTariffNumbers = this.$store.getters['customsTariffNumber/customsTariffNumbers'];
        let vats = this.$store.getters['vat/vats'];
        let countries = this.$store.getters['country/countries'];
        if(!productCategories.length) {
          await this.$store.dispatch('productCategory/fetchAll');
          productCategories = this.$store.getters['productCategory/productCategories'];
        }
        if(!manufacturers.length) {
          await this.$store.dispatch('manufacturer/fetchAll');
          manufacturers = this.$store.getters['manufacturer/manufacturers'];
        }
        if(!countries.length) {
          await this.$store.dispatch('country/fetchAll');
          countries = this.$store.getters['country/countries'];
        }
        if (!vats.length) {
          await this.$store.dispatch('vat/fetchAll');
          vats = this.$store.getters['vat/vats'];
        }
        if(!customsTariffNumbers.length) {
          await this.$store.dispatch('customsTariffNumber/fetchAll');
          customsTariffNumbers = this.$store.getters['customsTariffNumber/customsTariffNumbers'];
        }
        this.config = [
          {
            type: 'text',
            name: 'name',
            label: 'Név',
            defaultSearch: true
          },
          {
            type: 'text',
            name: 'id',
            label: 'Azonosító',
          },
          {
            type: 'text',
            name: 'ean',
            label: 'Vonalkód',
          },
          {
            type: 'select',
            name: 'category_id',
            label: 'Kategória',
            options: productCategories,
            labelCallback: category => category && `${category.name}` || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            name: 'origin_country_id',
            label: 'Származási ország',
            options: countries,
            labelCallback: country => country && `${country.name}` || '',
            valueKey: 'id',
          },
          {
            type: 'remote',
            name: 'supplier_id',
            label: 'Beszállító',
            labelCallback: partner => partner && `#${partner.id} ${partner.company.name}` || '',
            valueKey: 'id',
            remoteSearchParam: 'name',
            remoteAction: 'partner/search',
          },
          {
            type: 'select',
            name: 'status',
            options: [
              { label: 'Aktív', status: 'active' },
              { label: 'Inaktív', status: 'inactive' },
              { label: 'Kifutó', status: 'run-out' },
              { label: 'Kifutó és inaktív', status: 'run-out-inactive' },
              { label: 'Láthatatlan', status: 'hidden' },
            ],
            label: 'Státusz',
            labelCallback: status => status.label,
            valueKey: 'status',
          },
          {
            type: 'select',
            name: 'vat_id',
            options: vats,
            label: 'Áfa',
            labelCallback: vat => vat && `${vat.value}%` || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            name: 'customs_tariff_number_id',
            options: customsTariffNumbers,
            label: 'Vámtarifaszám',
            labelCallback: ctf => ctf && `${ctf.value}` || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            name: 'is_billable',
            options: [
              { label: 'Igen', value: 1 },
              { label: 'Nem', value: 0 },
            ],
            label: 'Számlázandó',
            labelCallback: status => status.label,
            valueKey: 'value',
          },
          {
            type: 'select',
            name: 'is_available_for_representatives',
            options: [
              { label: 'Igen', value: 1 },
              { label: 'Nem', value: 0 },
            ],
            label: 'Képviselő rendelheti',
            labelCallback: status => status.label,
            valueKey: 'value',
          },
        ];
      }
    }
  };
</script>
